require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _color = _interopRequireDefault(require("color"));

var _ActivityIndicator = _interopRequireDefault(require("./ActivityIndicator"));

var _Icon = _interopRequireDefault(require("./Icon"));

var _Surface = _interopRequireDefault(require("./Surface"));

var _Text = _interopRequireDefault(require("./Typography/Text"));

var _TouchableRipple = _interopRequireDefault(require("./TouchableRipple"));

var _colors = require("../styles/colors");

var _theming = require("../core/theming");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Button.tsx";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Button = function (_React$Component) {
  (0, _inherits2["default"])(Button, _React$Component);

  function Button() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Button)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      elevation: new _reactNative.Animated.Value(_this.props.mode === 'contained' ? 2 : 0)
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePressIn", function () {
      if (_this.props.mode === 'contained') {
        var scale = _this.props.theme.animation.scale;

        _reactNative.Animated.timing(_this.state.elevation, {
          toValue: 8,
          duration: 200 * scale,
          useNativeDriver: false
        }).start();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePressOut", function () {
      if (_this.props.mode === 'contained') {
        var scale = _this.props.theme.animation.scale;

        _reactNative.Animated.timing(_this.state.elevation, {
          toValue: 2,
          duration: 150 * scale,
          useNativeDriver: false
        }).start();
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          compact = _this$props.compact,
          mode = _this$props.mode,
          dark = _this$props.dark,
          loading = _this$props.loading,
          icon = _this$props.icon,
          buttonColor = _this$props.color,
          children = _this$props.children,
          uppercase = _this$props.uppercase,
          accessibilityLabel = _this$props.accessibilityLabel,
          onPress = _this$props.onPress,
          style = _this$props.style,
          theme = _this$props.theme,
          contentStyle = _this$props.contentStyle,
          labelStyle = _this$props.labelStyle,
          testID = _this$props.testID,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["disabled", "compact", "mode", "dark", "loading", "icon", "color", "children", "uppercase", "accessibilityLabel", "onPress", "style", "theme", "contentStyle", "labelStyle", "testID"]);
      var colors = theme.colors,
          roundness = theme.roundness;
      var font = theme.fonts.medium;
      var backgroundColor, borderColor, textColor, borderWidth;

      if (mode === 'contained') {
        if (disabled) {
          backgroundColor = (0, _color["default"])(theme.dark ? _colors.white : _colors.black).alpha(0.12).rgb().string();
        } else if (buttonColor) {
          backgroundColor = buttonColor;
        } else {
          backgroundColor = colors.primary;
        }
      } else {
        backgroundColor = 'transparent';
      }

      if (mode === 'outlined') {
        borderColor = (0, _color["default"])(theme.dark ? _colors.white : _colors.black).alpha(0.29).rgb().string();
        borderWidth = _reactNative.StyleSheet.hairlineWidth;
      } else {
        borderColor = 'transparent';
        borderWidth = 0;
      }

      if (disabled) {
        textColor = (0, _color["default"])(theme.dark ? _colors.white : _colors.black).alpha(0.32).rgb().string();
      } else if (mode === 'contained') {
        var isDark;

        if (typeof dark === 'boolean') {
          isDark = dark;
        } else {
          isDark = backgroundColor === 'transparent' ? false : !(0, _color["default"])(backgroundColor).isLight();
        }

        textColor = isDark ? _colors.white : _colors.black;
      } else if (buttonColor) {
        textColor = buttonColor;
      } else {
        textColor = colors.primary;
      }

      var rippleColor = (0, _color["default"])(textColor).alpha(0.32).rgb().string();
      var buttonStyle = {
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderWidth: borderWidth,
        borderRadius: roundness
      };
      var touchableStyle = {
        borderRadius: style ? _reactNative.StyleSheet.flatten(style).borderRadius || roundness : roundness
      };

      var _ref = _reactNative.StyleSheet.flatten(labelStyle) || {},
          customLabelColor = _ref.color,
          customLabelSize = _ref.fontSize;

      var textStyle = _objectSpread({
        color: textColor
      }, font);

      var elevation = disabled || mode !== 'contained' ? 0 : this.state.elevation;
      return React.createElement(_Surface["default"], (0, _extends2["default"])({}, rest, {
        style: [styles.button, compact && styles.compact, {
          elevation: elevation
        }, buttonStyle, style],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 257
        }
      }), React.createElement(_TouchableRipple["default"], {
        borderless: true,
        delayPressIn: 0,
        onPress: onPress,
        onPressIn: this.handlePressIn,
        onPressOut: this.handlePressOut,
        accessibilityLabel: accessibilityLabel,
        accessibilityTraits: disabled ? ['button', 'disabled'] : 'button',
        accessibilityComponentType: "button",
        accessibilityRole: "button",
        accessibilityStates: disabled ? ['disabled'] : [],
        disabled: disabled,
        rippleColor: rippleColor,
        style: touchableStyle,
        testID: testID,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 267
        }
      }, React.createElement(_reactNative.View, {
        style: [styles.content, contentStyle],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 283
        }
      }, icon && loading !== true ? React.createElement(_reactNative.View, {
        style: styles.icon,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 285
        }
      }, React.createElement(_Icon["default"], {
        source: icon,
        size: customLabelSize || 16,
        color: customLabelColor || textColor,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 286
        }
      })) : null, loading ? React.createElement(_ActivityIndicator["default"], {
        size: customLabelSize || 16,
        color: customLabelColor || textColor,
        style: styles.icon,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 294
        }
      }) : null, React.createElement(_Text["default"], {
        numberOfLines: 1,
        style: [styles.label, compact && styles.compactLabel, uppercase && styles.uppercaseLabel, textStyle, font, labelStyle],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 300
        }
      }, children))));
    }
  }]);
  return Button;
}(React.Component);

(0, _defineProperty2["default"])(Button, "defaultProps", {
  mode: 'text',
  uppercase: true
});

var styles = _reactNative.StyleSheet.create({
  button: {
    minWidth: 64,
    borderStyle: 'solid'
  },
  compact: {
    minWidth: 'auto'
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  icon: {
    marginLeft: 12,
    marginRight: -4
  },
  label: {
    textAlign: 'center',
    letterSpacing: 1,
    marginVertical: 9,
    marginHorizontal: 16
  },
  compactLabel: {
    marginHorizontal: 8
  },
  uppercaseLabel: {
    textTransform: 'uppercase'
  }
});

var _default = (0, _theming.withTheme)(Button);

exports["default"] = _default;